<template lang="pug">
.layout.l-default( :class='classes' )
  k-site-header( v-if='!noHeader' )
  slot
  k-nav-main( :menu='menu' :logo='site.logo' :title='site.title' )
  wp-footer( v-if='!noFooter' )
  overlay
  sidebar( pos='left' )
  sidebar( pos='right' )
  modal
</template>

<script lang="js">
import KSiteHeader from '@/blocks/k-site-header'
import KNavMain from '@/blocks/k-nav-main'
import WpFooter from '@/components/wp-footer'
import Overlay from '@/components/overlay'
import Modal from '@/components/modal'
import Sidebar from '@/components/sidebar'

export default {
  name: 'DefaultLayout',
  mixins: [],
  components: {
    KSiteHeader,
    KNavMain,
    WpFooter,
    Overlay,
    Modal,
    Sidebar,
  },
  props: {
    noHeader: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      unsubscribe: null,
      scrolledUp: false,
      scrolledDown: false,
      scrollAtTop: true
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe(( mutation, state ) => {
      if ( mutation.type === 'scrolledDown' ) {
        this.scrolledDown = true
        this.scrolledUp = false
        this.scrollAtTop = false
      } else if ( mutation.type === 'scrolledUp' ) {
        this.scrolledDown = false
        this.scrolledUp = true
      } else if ( mutation.type === 'scrollAtTop' ) {
        this.scrollAtTop = true
      }
    })
  },
  mounted() {},
  methods: {},
  beforeDestroy() {
    if ( this.unsubscribe ) this.unsubscribe()
  },
  computed: {
    menu() {
      return this.$store.state.menus.nav || []
    },
    site() {
      return {
        title: this.$store.state.site.title || 'My Blog',
        url: this.$store.state.site.url, // TODO: or?
        description: this.$store.state.site.description,
      }
    },
    classes() {
      return {
        'scrolled-down': this.scrolledDown,
        'scrolled-up': this.scrolledUp,
        'scroll-at-top': this.scrollAtTop,
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.l-default {
  --c-text: #def; /*TODO: fix*/
  .page {
    position: relative;
    z-index: 2;
    > .main {
      position: relative;
    }
    > .bottom-spacer {
      height: 15em;
      @include for-mobile {
        height: 2em;
      }
    }
  }
}
</style>
